import { Component, OnInit } from '@angular/core';
import { AppEvent, AppEventService } from 'pumpcalc-core';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-share-dialogue',
  templateUrl: './share-dialogue.component.html',
  styleUrls: ['./share-dialogue.component.css']
})
export class ShareDialogueComponent implements OnInit {

  show = false;
  pumpset;
  shareUrl;
  constructor(private appEventService: AppEventService) {
    this.appEventService.events.subscribe((event: AppEvent) => {
      if (event.name == "SHARE") {
        this.show = this.pumpset?true:false;
      }
      if (event.name == "PUMPSET-SHARE") {
        this.pumpset = event.data;
        this.shareUrl = environment.shareUrl + '?share=' + this.pumpset.id;        
      }
    })
  }

  ngOnInit(): void {
  }

  copyLinkToClipBoard(val: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.innerText = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

}
